import revive_payload_client_4sVQNw7RlN from "/usr/src/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/usr/src/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import zebline_script_client_zxU5D1wn7N from "/usr/src/app/plugins/zebline-script.client.ts";
import payload_client_yVLowv6hDl from "/usr/src/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/usr/src/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/usr/src/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/usr/src/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/usr/src/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/usr/src/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_3rw1Iqhpn2 from "/usr/src/app/node_modules/vue3-perfect-scrollbar/nuxt/dist/runtime/plugin.mjs";
import plugin_tbFNToZNim from "/usr/src/app/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_client_OVoKJro5pc from "/usr/src/app/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import apexchart_client_5d6ra58DX6 from "/usr/src/app/plugins/apexchart.client.ts";
import muchat_client_QuISPUUy9s from "/usr/src/app/plugins/muchat.client.ts";
import sentry_3AyO8nEfhE from "/usr/src/app/plugins/sentry.ts";
import toastification_client_7C0evqwO5y from "/usr/src/app/plugins/toastification.client.ts";
import vuetify_7h9QAQEssH from "/usr/src/app/plugins/vuetify.ts";
import window_mY4jZ4wBC5 from "/usr/src/app/plugins/window.ts";
import api_GFfDXud5Cr from "/usr/src/app/plugins/api.ts";
import zebline_api_k1swhopcbU from "/usr/src/app/plugins/zebline-api.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  zebline_script_client_zxU5D1wn7N,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_3rw1Iqhpn2,
  plugin_tbFNToZNim,
  plugin_client_OVoKJro5pc,
  apexchart_client_5d6ra58DX6,
  muchat_client_QuISPUUy9s,
  sentry_3AyO8nEfhE,
  toastification_client_7C0evqwO5y,
  vuetify_7h9QAQEssH,
  window_mY4jZ4wBC5,
  api_GFfDXud5Cr,
  zebline_api_k1swhopcbU
]